import React from 'react';
import classes from './Circle.module.css';

export const Circle = ({size, width, top, left}) => {

    const circleWidth = "calc(100% - " + width + "px)";
    
    return(
        <div className={classes.circle} style={{width: size, height: size, top: top, left: left}}>
            <div className={classes.circleChild} style={{width: circleWidth, height: circleWidth}}></div>
        </div>
    );
}